<div class="db-error-section">
  <p>{{'THANK_YOU'|translate}}</p>
  <p>{{'ERROR.REGISTER_REACHED_MAXIMUM_NUMBER'|translate}}</p>

</div>
